import React, { useCallback } from 'react';
import { Owner } from '@scale/shared/types/corp/lookup';
import { Modal, ModalBody, ModalHeader } from 'design-system/Modal';
import { Alert, FormLabel } from 'design-system';
import GiveCorpPermissionRole from 'react-scale/containers/corp/corp-permissions/GiveCorpPermissionRole';
import RevokeCorpPermissionRole from 'react-scale/containers/corp/corp-permissions/RevokeCorpPermissionRole';

type Props = {
  corpPermissionRoleId: string;
  isOpen: boolean;
  owners: Owner[];
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const UpdateProjectOwnersModal = ({
  corpPermissionRoleId,
  isOpen,
  owners,
  setModalIsOpen,
}: Props) => {
  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, [setModalIsOpen]);

  return (
    <Modal isOpen={isOpen}>
      <ModalHeader onRequestClose={closeModal}>Project Owners</ModalHeader>
      <Alert>
        Permissions can only be granted or revoked by existing project owners. If no one is listed
        as an owner currently, or if all owners are non-onsite users, onsite users may add
        themselves as owners.
      </Alert>
      <ModalBody>
        <FormLabel color="primary">Add Project Owner</FormLabel>
        <GiveCorpPermissionRole corpPermissionRoleId={corpPermissionRoleId} showRole={false} />
        <FormLabel color="primary">Remove Project Owner</FormLabel>
        <RevokeCorpPermissionRole
          corpPermissionRoleId={corpPermissionRoleId}
          showRole={false}
          usersWithRole={owners}
        />
      </ModalBody>
    </Modal>
  );
};

export default UpdateProjectOwnersModal;
